import { createFileRoute } from "@tanstack/react-router";
import NewPassword from "@/auth/new-password";

export const Route = createFileRoute("/(root)/root-user/new-password")({
  component: () => <NewPassword isSuperadmin={true} />,
});
